const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function getAnimationElements(rootEl = document) {
  if (rootEl === document) {
    return Array.from(document.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  }
  if (!(rootEl instanceof Element)) return [];
  const elements = [];
  if (rootEl.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) elements.push(rootEl);
  elements.push(...rootEl.querySelectorAll('.' + SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  return elements;
}

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const element = entry.target;
    if (entry.isIntersecting) {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (element.hasAttribute('data-cascade')) {
        element.style.setProperty('--animation-order', index);
      }
      observer.unobserve(element);
    } else {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = getAnimationElements(rootEl);
  if (!elements.length) return;

  if (isDesignModeEvent) {
    elements.forEach((element) => element.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px'
  });

  elements.forEach((element) => observer.observe(element));
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger(), { once: true });
} else {
  initializeScrollAnimationTrigger();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}